import { ResponsiveBreakpointsChecker } from "services/responsiveBreakpointsChecker";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const App: any;

export enum ApplicationPlatforms {
  Web = "web",
  Mobile = "mobile",
  Desktop = "desktop",
}

export function getApplicationPlatform(): ApplicationPlatforms {
  return ApplicationPlatforms.Web;
}

export const hasAudioSupport = !!window.document.createElement("audio").canPlayType;

export function isWindowFocused(): boolean {
  return !!App.views.content.windowFocused();
}

export function isTabFocused(): boolean {
  return document.hasFocus();
}

export function isMobileDevice(): boolean {
  return ResponsiveBreakpointsChecker.instance().isMobileDeviceWidth();
}
